import React, { SVGProps } from 'react';
import './MyEmergencyDrLogo.css';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  medlogo: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export default function MyEmergencyDrLogo(props: SVGProps<SVGSVGElement>) {
  const classes = useStyles();

  return (
    <span className={classes.medlogo}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-label="My Emergency Doctor Logo"
        role="img"
        viewBox="-15 -15 125 123"
        className="svg-medlogo"
      >
        <defs></defs>
      </svg>
    </span>
  );
}

//<path className="cls-2" d="M361.48,487.61a12.68,12.68,0,0,1,11.14,6.62q7.13,5.14,14.16,0a12.71,12.71,0,0,1,5.09-5.11q5.16-7.12,0-14.16A12.7,12.7,0,1,1,404,475q-5.12,7,0,14.16a12.75,12.75,0,0,1,5.07,5.07q7.13,5.14,14.16,0a12.69,12.69,0,1,1,0,12.08q-7-5.13-14.16,0a12.72,12.72,0,0,1-5.1,5.08q-5.13,7.05,0,14.16a12.69,12.69,0,1,1-12.15,0q5.16-7.11,0-14.16a12.71,12.71,0,0,1-5.13-5.12q-7-5.13-14.16,0a12.69,12.69,0,1,1-11.14-18.77Z" transform="translate(-348.79 -451.15)"></path>
//<path className="cls-1" d="M361.48,451.15a12.69,12.69,0,1,1-12.69,12.69,12.69,12.69,0,0,1,12.69-12.69Zm72.93,72.93a12.69,12.69,0,1,1-12.69,12.69,12.7,12.7,0,0,1,12.69-12.69Zm0-72.93a12.69,12.69,0,1,1-12.69,12.69,12.7,12.7,0,0,1,12.69-12.69Zm-72.93,72.93a12.69,12.69,0,1,1-12.69,12.69,12.69,12.69,0,0,1,12.69-12.69Z" transform="translate(-348.79 -451.15)"></path>
